// extracted by mini-css-extract-plugin
export default {"ibanOptions":"IBANToggler_ibanOptions__ctGT4","active":"IBANToggler_active__Kr8Ps"};